import React, { useState, useEffect } from "react";
import { Table, Typography, Button, Space, Popover, Badge } from "antd";
import { useIntl } from "react-intl";
import moment from "moment";
import { EditOutlined, WarningOutlined } from "@ant-design/icons";
import SelectionActions from "./SelectionActions";
import { getFullName } from "../../../components/util/helpers";
import Date from "../../../components/tables/Date";
import Patient from "../../../components/tables/Patient";

import ReplaceEmployee from "./ReplaceEmployee";
import { useSelector } from "react-redux";

const { Text } = Typography;
const ListView = (props) => {
  const { filteredOrders, activePlan, onEdit, activePatient, replaceEmployee } =
    props;
  const [replaceEmployeeVisible, setReplaceEmployeeVisible] = useState(false);

  const intl = useIntl();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const conflict_events = useSelector(
    (state) => state.plan.activeSimulatedPlan.conflict_events
  );

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.plans.employee",
      }),
      dataIndex: "fullname",
      render(text, record) {
        const conflicts =
          conflict_events &&
          conflict_events.length > 0 &&
          conflict_events.filter(
            (item) =>
              item.conflict_weekday === record.weekday &&
              item.conflict_start_time_minutes === record.start_time_minutes
          );
        const conslictsCcolumns = [
          {
            title: intl.formatMessage({
              id: "app.plans.eventConflictsPatientName",
            }),
            dataIndex: "patient",
            render(text, record) {
              return <Patient record={record.order.patient} />;
            },
            width: "220px",
          },
          {
            title: intl.formatMessage({
              id: "app.plans.eventConflictsDate",
            }),
            dataIndex: "date",
            render(text) {
              return <Date text={text} format={"L"} />;
            },
            width: "140px",
          },
          {
            title: intl.formatMessage({
              id: "app.plans.dayInWeek",
            }),
            dataIndex: "date",
            render(text, record) {
              return <Text>{moment.weekdays(moment(text).weekday())}</Text>;
            },
            width: "80px",
          },
          {
            title: intl.formatMessage({
              id: "app.plans.eventConflictsStart",
            }),
            dataIndex: "date",
            render(text) {
              return <Date text={text} format={"HH:mm"} />;
            },
            width: "140px",
          },
          {
            title: intl.formatMessage({
              id: "app.plans.eventConflictsEnd",
            }),
            dataIndex: "date",
            render(text, record) {
              return (
                <Date
                  text={moment(text).add(record.duration_minutes, "minutes")}
                  format={"HH:mm"}
                />
              );
            },
            width: "140px",
          },
        ];

        const conflictsContent =
          conflicts && conflicts.length > 0 ? (
            <div style={{ width: "800px" }}>
              <Table
                bordered
                dataSource={conflicts}
                columns={conslictsCcolumns}
                pagination={false}
                scroll={{
                  y: window.innerHeight / 3,
                }}
              />
            </div>
          ) : null;

        return (
          <Space size="middle">
            <Text>{text}</Text>
            {conflicts && conflicts.length > 0 ? (
              <Popover
                content={conflictsContent}
                title={
                  <Badge
                    style={{ padding: "8px 0" }}
                    status="error"
                    text={intl.formatMessage({
                      id: "app.plans.eventConflictsTitle",
                    })}
                  />
                }
              >
                <WarningOutlined style={{ padding: "0 5px", color: "red" }} />
              </Popover>
            ) : null}
          </Space>
        );
      },

      width: "100px",
      defaultSortOrder: "descend",
      sorter: (a, b) => a["fullname"].localeCompare(b["fullname"]),
    },
    {
      title: intl.formatMessage({
        id: "app.plans.weekday",
      }),
      dataIndex: "weekday",
      render(text) {
        return <Text>{text !== undefined && moment.weekdays(text)}</Text>;
      },
      width: "70px",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.weekday - b.weekday,
    },
    {
      title: intl.formatMessage({
        id: "app.plans.start_time",
      }),
      dataIndex: "start_time_minutes",
      render(text) {
        return (
          <Date
            text={text && moment().startOf("day").set("minute", text)}
            format={"HH:mm"}
          />
        );
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.end_time",
      }),
      dataIndex: "end_time",
      render(text, record) {
        return (
          <Date
            text={
              record.start_time_minutes &&
              moment()
                .startOf("day")
                .set(
                  "minute",
                  record.duration_minutes + record.start_time_minutes
                )
            }
            format={"HH:mm"}
          />
        );
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.duration",
      }),
      dataIndex: "duration_minutes",
      render(text) {
        return <Text>{Math.round((text / 60) * 100) / 100}</Text>;
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.plans.client",
      }),
      dataIndex: "clientName",
      width: "100px",
      defaultSortOrder: "descend",
      sorter: (a, b) => a["clientName"].localeCompare(b["clientName"]),
    },
    {
      title: intl.formatMessage({
        id: "app.references.actions",
      }),
      width: "150px",
      render(text, record) {
        return (
          <Button
            type="link"
            onClick={() => {
              onEditEvent(record);
            }}
          >
            <EditOutlined style={{}} />
          </Button>
        );
      },
    },
  ];

  const onEditEvent = (item) => {
    var startOfWeek = moment().startOf("week");
    const day = startOfWeek.add(item.weekday, "days");
    const startDate = day.set("minute", item.start_time_minutes);
    const start = startDate.toDate();
    const end = startDate.add(item.duration_minutes, "minutes").toDate();
    const converted = { ...item, start, end };
    onEdit(converted);
  };

  let arr = [];
  if (
    activePlan &&
    activePlan["recurrent_events"] &&
    activePlan["recurrent_events"].length > 0
  ) {
    activePlan["recurrent_events"].forEach((item, i) => {
      var isFiltered = filteredOrders.includes(item.order_id);
      if (!isFiltered) {
        arr.push(item);
      }
    });
  }
  const events = arr.map((i) => {
    return {
      ...i,
      fullname: i?.employee
        ? getFullName(i.employee?.surename, i.employee?.first_name)
        : intl.formatMessage({
            id: "app.plans.noScheduledEmployee",
          }),
      clientName: i?.order?.client?.name,
    };
  });

  const rowSelection = {
    selectedRowKeys,
    onSelect: (record, selected, selectedRows, nativeEvent) => {
      const arr = selected
        ? [...selectedRowKeys, record.id]
        : selectedRowKeys.filter((i) => i !== record.id);
      setSelectedRowKeys(arr);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const ids =
        selectedRows && selectedRows.length > 0
          ? selectedRows.filter((k) => !k.titleRow).map((r) => r.id)
          : [];
      setSelectedRowKeys(ids);
    },
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  };

  const actionsFooter = () => (
    <SelectionActions
      selectedRowKeys={selectedRowKeys}
      onShowReplaceEmployee={onShowReplaceEmployee}
    />
  );

  const showFooter = selectedRowKeys && selectedRowKeys.length > 0;

  const tableProps = {
    footer: showFooter ? actionsFooter : undefined,
  };

  const onShowReplaceEmployee = () => {
    setReplaceEmployeeVisible(true);
  };

  const onHideReplaceEmployee = () => {
    setReplaceEmployeeVisible(false);
  };

  const onRplaceEmployee = (selectedEmployee) => {
    replaceEmployee(selectedEmployee, selectedRowKeys);
    onHideReplaceEmployee();
  };

  return (
    <div>
      <Table
        bordered
        pagination={false}
        rowKey={(record) => record.id}
        scroll={{ y: window.innerHeight - 256 }}
        rowSelection={rowSelection}
        columns={columns}
        dataSource={events}
        {...tableProps}
      />
      <ReplaceEmployee
        visible={replaceEmployeeVisible}
        hide={onHideReplaceEmployee}
        branchId={activePatient.branch}
        onSubmit={onRplaceEmployee}
      />
    </div>
  );
};
export default ListView;
